import { useEffect, useRef } from "react";
export default function AdvancedMarker(param) {
    var map = param.map, position = param.position, title = param.title, content = param.content, onClick = param.onClick;
    var markerRef = useRef(null);
    useEffect(function() {
        var _window_google_maps_marker, _window_google_maps, _window_google;
        if (!map || !((_window_google = window.google) === null || _window_google === void 0 ? void 0 : (_window_google_maps = _window_google.maps) === null || _window_google_maps === void 0 ? void 0 : (_window_google_maps_marker = _window_google_maps.marker) === null || _window_google_maps_marker === void 0 ? void 0 : _window_google_maps_marker.AdvancedMarkerElement)) return;
        // เคลียร์ marker เก่า
        if (markerRef.current) {
            markerRef.current.map = null;
        }
        // สร้าง content element
        var contentEl = typeof content === "string" ? function() {
            var div = document.createElement("div");
            div.innerHTML = content;
            return div;
        }() : content;
        // สร้าง AdvancedMarkerElement
        var marker = new window.google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: position,
            title: title,
            content: contentEl || undefined
        });
        // ให้ onClick ส่ง marker instance กลับ
        if (onClick) {
            marker.addListener("click", function(e) {
                return onClick(marker, e);
            });
        }
        markerRef.current = marker;
        return function() {
            if (marker) marker.map = null;
        };
    }, [
        map,
        position,
        title,
        content,
        onClick
    ]);
    return null;
}
